import { isType } from "@src/utils";
import { requiredValidate } from "../utils";
import request from "ynf-core-engine/request";

function convertToBlob(data = '', fileName = 'download') {
  // 将二进制流转为blob
  const blob = new Blob([data], { type: 'application/octet-stream' });
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
    window.navigator.msSaveBlob(blob, decodeURI(fileName));
  } else {
    // 创建新的URL并指向File对象或者Blob对象的地址
    const blobURL = window.URL.createObjectURL(blob);
    // 创建a标签，用于跳转至下载链接
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = blobURL;
    link.setAttribute('download', decodeURI(fileName));
    // 兼容：某些浏览器不支持HTML5的download属性
    if (typeof link.download === 'undefined') {
      link.setAttribute('target', '_blank');
    }
    // 挂载a标签
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // 释放blob URL地址
    window.URL.revokeObjectURL(blobURL);
  }
}

/**
 * exportFile
 * @param rootStore
 * @param options {
 *  // 必填字段
 *  url: string
 *  // 选填字段
 *  fileName: string
 *  method: 'post|get',  默认值：'get',
 *  params: Object
 *  data: Object
 *  headers: Object
 * }
 * @returns
 */
export async function exportFile(rootStore: any, options: any = {}) {
  requiredValidate.call(this, options, ['url']);
  const { utils = {}, pageStore = {} } = rootStore;
  let { url, fileName, ...requestOptions } = options;
  try {
    const res = await request({ 
      url, 
      method: 'get', 
      ...requestOptions,
      headers: {
        withCredentials: true,
        ...options.headers
      },
    });
    const { headers = {} } = res;
    if (/^application\/json/.test(headers['content-type'])) {
      const resData = res.data ?? res;
      throw new Error(`${ isType(resData, 'Object')? JSON.stringify(resData) : resData }`)
    }
    const analysisFileName = headers?.['content-disposition']?.match(/filename=(.*)/)?.[1] ?? url?.match(/\/([^\\/\\?#]+)(?=[^\\/]*$)/)?.[1];
    if (fileName && 
      analysisFileName && 
      fileName !== analysisFileName) {
      try {
        await rootStore.utils.confirm({ title: `${lang.templateByUuid('UID:P_CORE-YNF-FE_191DEBDE05900022', '确认是否继续采用传入的文件名？')}`, content: lang.localeUuid('UID:P_CORE-YNF-FE_191DDE9804500004', {fileName, analysisFileName}), ...options.confirmOptions });
        convertToBlob(res.data, fileName);
        utils.message.success(`${lang.templateByUuid('UID:P_CORE-YNF-FE_191DE22E04500004', '下载完成')}，${ fileName }`);
      } catch (err: any) { 
        convertToBlob(res.data, analysisFileName);
        utils.message.success(`${lang.templateByUuid('UID:P_CORE-YNF-FE_191DE22E04500004', '下载完成')}，${ analysisFileName }`);
      }
    } else {
      convertToBlob(res.data, (fileName || analysisFileName));
      utils.message.success(`${lang.templateByUuid('UID:P_CORE-YNF-FE_191DE22E04500004', '下载完成')}，${ (fileName || analysisFileName) }`);
    }
  } catch (err: any) {
    utils.message.danger(err?.message);
    return Promise.reject(err);
  }
}
